<template>
  <div class="profile">
      <ProfileModal
        v-if="showModal"
        :show="showModal"
        @closeModal="showModal=false"
        />
      <div class="profile-data">

          <div v-if="!isShowing" class="data" :class="[{hideOn : !isShowing, hideOff : !isShowing&&firstState}, data]">
            <p class="name">{{nombre}} {{apellido}}</p>
            <p class="mail">{{email}}</p>
          </div>

        <div :class="[{bgAnimationOn : isShowing, bgAnimationOff : !isShowing&&firstState}, profileWrapper]">
          <div :class="[{avatarSizeOn : isShowing}, avatar]" @click="toggleShow">
            <img :src="avatarImage" alt="Avatar" v-if="avatarImage" >
            <img src="@/assets/avatar.png" alt="Avatar" v-else >
          </div>
          <button v-if="isShowing" class="background-fix edit-profile" @click="activeProfile">
            <i class="icon ico-user"></i>
            <p>Editar perfil</p>
          </button>
          <button v-if="isShowing" @click="logout" class="background-fix logout">
            <i class="icon ico-logout"></i>
            <p>Cerrar sesión</p>
          </button>
          <button v-if="isShowing" @click="closeProfile" class="btn-open-menu">
            <i class="icon ico-close"></i>
          </button>
        </div>
        
      </div>
      <div class="profile-card" v-if="isProfile&&isShowing"> 
          <label for="avatar" class="avatar" @dragover.prevent @drop="onDrop" >
              

            <img :src="avatarImage" alt="Avatar" v-if="avatarImage" >
            <img src="@/assets/avatar.png" alt="Avatar" v-else >
            <span class="add-picture">
              <i class="icon ico-camera"></i>
            </span>
          </label>
          <input type="file" name="avatar" id="avatar" class="input-hidden" @change="onChange" >


          <div class="info-profile">
            <h6>Información del perfil:</h6>
            <label class="card-form-label">Nombre:</label>
              <input type="text" class="card-form-input" :class="title ?  'active' : ''" placeholder="Máximo 20 carácteres" maxlength="20" v-model="nombre">
            <label class="card-form-label">Apellido:</label>
            <input type="text" class="card-form-input" :class="title ?  'active' : ''" placeholder="Máximo 20 carácteres" maxlength="20" v-model="apellido">
            <label class="card-form-label">Correo electrónico:</label>
            <input type="text" class="card-form-input disabled" disabled :class="title ?  'active' : ''" placeholder="mail@mimail.com" maxlength="20" v-model="email">
          </div>
          <div class="password-profile">
            <hr>
            <div class="title">
              <h6>Contraseña</h6>
              <button class=" button quiet" v-if="isProfile&&!isChange" @click="changePass">
                <i class="icon ico-lock"></i>
                <p>Cambiar</p>
              </button>
            </div>
            <div class="hide-pass" v-if="isChange">
              <label class="card-form-label">Nueva contraseña</label>
              <button class="button quiet btn-hide" v-if="!hidePass" @click="showPass">
                <i class="icon ico-hide"></i>
                <p>Esconder</p>
              </button>
              <button class="button quiet btn-show" v-if="hidePass" @click="showPass">
                <i class="icon ico-view"></i>
                <p>Mostrar</p>
              </button>
            </div>
              <input v-if="isChange" :type="hidePass ? 'password' : 'text'" class="card-form-input" :class="title ?  'active' : ''" placeholder="Escribe tu nueva contraseña" maxlength="20" v-model="password">
            <hr>
          </div>
          

          <div class="actions">
            <button class=" button md cancel" @click="toggleShow">
              <p>Cancelar</p> 
            </button>
            <div id="total" v-if="!loader">
              <button class="save button md primary" @click="updateUser">
                <p>Guardar</p>
              </button>
            </div>
            <div v-else>
            <Loader/>
            </div>
            <div v-if="loader"> 
            </div>
            
          </div>
          </div>
  </div>  
</template>

<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import ProfileModal from '@/components/modals/ProfileModal'
export default {
  name: 'Profile',
  components: {
        Loader,
        ProfileModal
  },
  data(){
    return{
      isShowing: false, 
      isProfile: false, 
      hidePass: true,
      isChange: false,
      profileWrapper:'profile-wrapper',
      avatar: 'avatar',
      avatarImage: null,
      firstState: false,
      file: null,
      data: 'data',
      inputType: 'password',
      nombre: "",
      nombreReal: "",
      apellido: "",
      apellidoReal: "",
      email: "",
      password: "",
      loader: false,
      showModal: false,
    }
  },
  mounted: function(){
        this.email= localStorage.getItem('userEmail')

        axios.get(process.env.VUE_APP_CORE_HOST+"/api/v1/user/?email="+this.email)
          .then((res) => {
            
            this.nombre = res.data.first_name
            this.nombreReal = res.data.first_name
            this.apellido = res.data.last_name
            this.apellidoReal = res.data.last_name
            try {
              this.avatarImage = process.env.VUE_APP_CORE_HOST+"/media"+res.data.avatar.split("media")[1]
            } catch (error) {
              console.log(error)
            }

            localStorage.setItem('user_id', res.data.id)

          })
          .catch((err) => {
              console.log(err)
              
          })
  },
  methods: {
    updateUser(){

        this.loader = true
        this.showModal = true
        
        axios.patch(process.env.VUE_APP_CORE_HOST+"/api/v1/user/"+localStorage.getItem('user_id')+"/", {
          first_name: this.nombre,
          last_name: this.apellido
        })
          .then((res) => {
            this.nombre = res.data.first_name
            this.nombreReal = res.data.first_name
            this.apellido = res.data.last_name
            this.apellidoReal = res.data.last_name

            if(this.password != ""){
              axios.post(process.env.VUE_APP_CORE_HOST+"/api/v1/user/change_password/", {
                user_id: localStorage.getItem('user_id'),
                new_password: this.password
              })
                .then((res) => {
                    this.loader = false
                    this.firstState= true;
                    this.isShowing= !this.isShowing;
                    
                    this.$emit('showModal')
                })
                .catch((err) => {
                    console.log(err)
                })
            }else{
              this.loader = false
              this.firstState= true;
              this.isShowing= !this.isShowing;
              this.$emit('showModal')
            }
              
          })
          .catch((err) => {
              console.log(err)
              
          })
    },
    hideModal: function(){
      this.showModal = false
    },
    toggleShow(){
      this.isShowing= !this.isShowing;
      this.isProfile= false;
      this.isChange= false;
      this.nombre = this.nombreReal
      this.apellido = this.apellidoReal
    },
    closeProfile(){
      this.firstState= true;
      this.isShowing= !this.isShowing;
      this.nombre = this.nombreReal
      this.apellido = this.apellidoReal
    },
    activeProfile(){
      this.isProfile= !this.isProfile;
    },
    showPass(){
      this.hidePass= !this.hidePass;
    },
    changePass(){
      this.isChange= !this.isChange;
    },
    logout: function(){
            this.$store.dispatch("auth/changeModal", true)
    },
    onDrop: function(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.createFile(files[0]);
    },
    onChange(e) {
      var files = e.target.files;
      this.createFile(files[0]);
    },
    createFile(file) {
      if (!file.type.match('image.*')) {
        // alert('Select an image');
        return;
      }
      var reader = new FileReader();
      var vm = this;
      // Pasamos valor
      reader.onload = function(e) {
        vm.avatarImage = e.target.result;
        // vm.setOfferPreview(vm.preview);
      }
      this.file = file
      reader.readAsDataURL(file);
      // this.setOfferImage(file)
      var bodyFormData = new FormData();
      console.log(file)

      bodyFormData.append('avatar', file); 

      axios({
        method: 'patch',
        url: process.env.VUE_APP_CORE_HOST+"/api/v1/user/"+localStorage.getItem('user_id')+"/",
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(function (response) {
          try {
            vm.avatarImage = process.env.VUE_APP_CORE_HOST+"/media"+response.data.avatar.split("/media")[1]
          } catch (error) {
            console.log(error)
          }
      })
      .catch(function (response) {
          //handle error
          console.log(response);
      });
    },
  }
}
</script>
<style lang="sass">
.card-form-label
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    color: #636363
    display: block
    margin-bottom: 8px
.card-form-input
    width: calc(100% - 18px)
    border: none
    outline: none
    background: #f0f4f5
    border-left: 2px solid $dark-grey
    padding: 6px 8px
    font-family: $body-font
    font-size: 16px
    font-weight: 600
    color: $dark
.card-form-input.active
    border-color: $secondary
.card-form-input.disabled
    width: calc( 100% - 16px)
    border-left: none
    color: #999999 !important
.card-form-input::placeholder
    font-family: $body-font
    font-size: 16px
    font-weight: 600
    color: $dark
    opacity: 0.4
.card-form-input.disabled::placeholder
    opacity: 0.2
.profile-card input:focus
  border-left: 2px solid $secondary
.input-hidden
    width: 0.1px
    height: 0.1px
    opacity: 0
    overflow: hidden
    position: absolute
    top: 0
    z-index: -1


.link
  margin-top: $sm
  font-family: $body-font
  color: $dark
  font-weight: 400
  &:hover
    color: $primary-hover
.profile
  width: 325px
  display: flex
  justify-content: flex-end
  float: right
  flex-direction: column
  @include mobile 
    width: auto
    z-index: 10
  button
    cursor: pointer
    border: none
  .profile-data
    display: flex
    justify-content: flex-end
    align-self: end
    margin-top: 8px
    align-items: center
    align-self: flex-end
    .data
      margin-right: 24px
      color: $white
      text-align: right
      order: 1
      @include mobile
        display: none
    .name
      font-family: $title-font
      font-size: 14px
      font-weight: 600
    .mail
      font-family: $body-font
      font-size: 12px
      font-weight: 300
  hr
    width: 90%
    align-self: center
    margin: $sm 0
    opacity: 0.3
    height: 0px
    border: 0.5px solid $dark-grey
  
    
  .avatar
    order: 1
    cursor: pointer
    display: flex
    img
      border: 4px solid $white
      border-radius: 100%
      width: 44px
      height: 44px
      box-shadow: $shadow-low
  .edit-profile
    order: 2
    color: $dark
    font-family: $body-font
    width: 70px
    height: 56px
    background: $white
    .icon
      font-size: 16px
    p
      font-size: 12px
    &:hover
      color: $secondary 
      border-bottom: 4px solid $secondary
      padding-top: 4px
      
  .logout
    order: 3
    font-family: $body-font
    width: 80px
    height: 56px
    color: $danger
    background: $white
    .icon
      font-size: 16px
    p
      font-size: 12px
    &:hover
      color: $danger 
      border-bottom: 4px solid $danger
      padding-top: 4px

  .btn-open-menu
    order: 4
    color: $white
    background: $light-grey
    width: 32px 
    height: 32px
    border-radius: 100%
    padding: 0
    display: flex
    align-items: center
    justify-content: center
    margin: 0px
    font-size: 16px
    padding: 8px
    .icon
      align-self: center
      width: 16px
      height: 16px

.profile-card
  width: 325px
  display: flex
  flex-direction: column
  z-index: 9
  background: $white
  box-sizing: border-box
  padding: $sm $xs
  margin-top: $xs
  border-radius: 8px
  box-shadow: $shadow-hi
  button
    display: flex
    align-self: center
  .avatar
    order: 1
    align-self: center
    display: grid
    grid-template-rows: 1fr 1fr 1fr
    grid-template-columns: 1fr 1fr 1fr
    width: 80px
    height: 80px
    img
      width: 80px
      height: 80px
      z-index: 3
      display: grid
      box-sizing: border-box
      grid-column: 1 / 3
      grid-row: 1/ 3
    .ico-camera
      color: $white
      align-self: center
      height: 16px
      width: 16px
    .add-picture
      background: $secondary
      width: 32px
      height: 32px
      border-radius: 100%
      display: grid
      align-items: center
      justify-content: center
      z-index: 4
      grid-column: 3 / 3
      grid-row: 3 / 3
    &:hover
      .add-picture
        background: $secondary-hover

  label
    margin-top: $sm    
  .info-profile
    order: 2
    margin-top: $md
  .password-profile
    order: 4
    margin-top: $sm
    display: flex
    align-items: center
    flex-direction: column
    .title
      display: flex
      flex-direction: row
      width: 100%
      margin-top: $xs
      h6
        order: 1
        flex-grow: 4
      button
        order: 2
        flex-grow: 1
    .hide-pass
      height: 20px
      display: flex
      align-items: center
      margin-bottom: $sm
      margin-top: $sm
      justify-content: space-between
      width: 100%
      label
        order: 1
        margin: 0px
        flex-grow: 4
      button
        order: 2
        flex-grow: 1
        width: 60px
      p
        margin-left: 8px  
  .actions
    display: flex
    flex-direction: row
    order: 4
    margin-top: $lg
    justify-content: space-between
    width: 90%
    align-self: center
    button.save
      width: 130px
      min-width: 130px
    button.cancel
      background: $white
      text-align: center
      width: 130px
      min-width: 130px
      font-family: $body-font
      font-size: 14px
      font-weight: normal
      &:hover
        background: $default

.profile-wrapper
    order: 2
    display: flex
    justify-content: space-between
    align-items: center
    align-self: flex-end
    padding: 0 8px 
    border-radius: 28px
    overflow-x: hidden
    box-sizing: border-box

.bgAnimationOn
  animation: growOn 0.4s forwards
.bgAnimationOff
  animation: growOff 0.4s forwards
.avatarSizeOn
  img
    animation: avatarSizeOn 0.3s forwards
.hideOn
  // animation: hide-on 0.2s forwards
  // background: red
  animation-delay: 0.1s
.hideOff
  // animation: hide-off 0.2s forwards
  // background: blue

@keyframes growOn
  0%
    width: 64px
    background: rgba(255,255,255,100)
  100%
    background: rgba(255,255,255,255)
    width: 325px

@keyframes growOff
  0%
    background: rgba(255,255,255,255)
    width: 325px
  100%
    width: 64px
    background: rgba(255,255,255,0)
  
@keyframes avatarSizeOn
  0%
    width: 44px
    height: 44px
  100%
    width: 36px
    height: 36px

@keyframes hide-on
  0%
    opacity: 0
  100% 
    opacity: 1

@keyframes hide-off
  0%
    opacity: 0
  100%
    opacity: 1

</style>